import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'reset-failed',
  templateUrl: './reset-failed.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule],
})
export class ResetFailedComponent {
  @Output() childEvent = new EventEmitter<boolean>();

  toggleIsClicked() {
    this.childEvent.emit(false);
  }
}
